import { KeyboardSensor, MouseSensor, PointerSensor, TouchSensor } from '@dnd-kit/core';

// dnd-kit listeners on a card/row also receive bubbled events from its controls.
// A control inside a draggable surface keeps its own keyboard and pointer action;
// the surface itself and dedicated drag handles remain drag activators.
const interactiveSelector = [
  'button', 'a[href]', 'input', 'select', 'textarea', 'label', 'summary',
  '[role="button"]', '[role="link"]', '[role="checkbox"]',
  '[contenteditable="true"]', '[tabindex]:not([tabindex="-1"])',
  '[data-dnd-ignore]',
].join(', ');

function isNestedControl(event: { target: EventTarget | null; currentTarget: EventTarget | null }, allowPointer: boolean) {
  const { target, currentTarget } = event;
  if (!(target instanceof Element) || !(currentTarget instanceof Element)) return false;
  const pointerHandle = target.closest('[data-dnd-allow-pointer]');
  if (allowPointer && pointerHandle && currentTarget.contains(pointerHandle)) return false;
  const control = target.closest(interactiveSelector);
  return !!control && control !== currentTarget && currentTarget.contains(control);
}

export class InteractiveSafeKeyboardSensor extends KeyboardSensor {
  static activators = KeyboardSensor.activators.map((activator) => ({
    ...activator,
    handler: (...args: Parameters<typeof activator.handler>) =>
      isNestedControl(args[0], false) ? false : activator.handler(...args),
  }));
}

export class InteractiveSafePointerSensor extends PointerSensor {
  static activators = PointerSensor.activators.map((activator) => ({
    ...activator,
    handler: (...args: Parameters<typeof activator.handler>) =>
      isNestedControl(args[0], true) ? false : activator.handler(...args),
  }));
}

export class InteractiveSafeMouseSensor extends MouseSensor {
  static activators = MouseSensor.activators.map((activator) => ({
    ...activator,
    handler: (...args: Parameters<typeof activator.handler>) =>
      isNestedControl(args[0], true) ? false : activator.handler(...args),
  }));
}

export class InteractiveSafeTouchSensor extends TouchSensor {
  static activators = TouchSensor.activators.map((activator) => ({
    ...activator,
    handler: (...args: Parameters<typeof activator.handler>) =>
      isNestedControl(args[0], true) ? false : activator.handler(...args),
  }));
}
